var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select"},_vm._l((_vm.options),function(item){return _c('div',{key:item.id,staticClass:"select-item",on:{"click":function($event){return _vm.selectItem(item)}}},[_vm._v(" "+_vm._s(item.label ? item.label : item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }